import React from 'react'
import {Locales} from "../../../localization/types";
import { externalLinks, pagesLinks } from "../../../pages-data/_V2/common/links";

import style from './styles.module.scss'


export const getData = (locale: Locales) => {
  if (locale === 'ru-BY') {
    return [
      {
        title: 'Цены',
        items: [
          {
            name: 'Стоимость одного терминала в месяц',
            web: '66 BYN',
            start: '85 BYN',
            standard: '110 BYN',
            pro: '170 BYN',
          },
          {
            name: 'Стоимость одного терминала в год / Выгода до 15%',
            web: '660 BYN',
            start: '900 BYN',
            standard: '1 200 BYN',
            pro: '1 800 BYN',
          },
          {
            name: 'Стоимость доп. терминала в месяц',
            web: '40 BYN',
            start: '',
            standard: '56 BYN',
            pro: '85 BYN',
          },
          {
            name: 'Стоимость доп. терминала в год / Выгода до 30%',
            web: '400 BYN',
            start: '',
            standard: '600 BYN',
            pro: '900 BYN',
          },
        ],
      },
      {
        title: 'Платформа кассового терминала',
        items: [
          {
            name: 'Операционная система',
            web: 'Windows, Android',
            start: 'iPadOS',
            standard: 'iPadOS',
            pro: 'iPadOS',
          },
        ],
      },
      {
        title: 'Ограничения',
        items: [
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.enterprise.href.slice(1)}`}
                    target="_blank"
                >
                  Компаний (юр.лиц)
                </a>
            ),
            web: 'Без ограничений',
            start: '1',
            standard: 'Без ограничений',
            pro: 'Без ограничений',
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.venue.href.slice(1)}`}
                    target="_blank"
                >
                  Заведений
                </a>
            ),
            web: 'Без ограничений',
            start: '1',
            standard: '5',
            pro: 'Без ограничений',
          },
          {
            name: 'Терминалов (касс)',
            web: 'Без ограничений',
            start: '2',
            standard: '10',
            pro: '50',
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.cookingplace.href.slice(1)}`}
                    target="_blank"
                >
                  Мест приготовления
                </a>
            ),
            web: 'Без ограничений',
            start: '2',
            standard: 'Без ограничений',
            pro: 'Без ограничений',
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.saleplace.href.slice(1)}`}
                    target="_blank"
                >
                  Мест реализации
                </a>
            ),
            web: 'Без ограничений',
            start: '2',
            standard: 'Без ограничений',
            pro: 'Без ограничений',
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.warehouse.href.slice(1)}`}
                    target="_blank"
                >
                  Складов
                </a>
            ),
            web: 'Без ограничений',
            start: '2',
            standard: 'Без ограничений',
            pro: 'Без ограничений',
          },
          {
            name: 'Сотрудников',
            web: 'Без ограничений',
            start: '10',
            standard: '30',
            pro: 'Без ограничений',
          },
          {
            name: 'Периферийных устройств (ФР, принтеров, весов и т. д.)',
            web: 'ФР и принтеры чеков без ограничений',
            start: '10',
            standard: '30',
            pro: 'Без ограничений',
          },
          {
            name: 'Поддержка дополнительных модулей',
            web: false,
            start: false,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: 'Техническая поддержка',
        items: [
          {
            name: 'Почта',
            web: '24/7',
            start: '24/7',
            standard: '24/7',
            pro: '24/7',
          },
          {
            name: 'Чат',
            web: '24/7',
            start: '24/7',
            standard: '24/7',
            pro: '24/7',
          },
          {
            name: 'Телефон (обращение по проблеме)',
            web: false,
            start: false,
            standard: '24/7',
            pro: '24/7',
          },
          {
            name: 'Телефон (консультация)',
            web: false,
            start: false,
            standard: false,
            pro: '24/7',
          },
        ],
        footer:
            'Тарифы Enterprise, Franchise, а также Trial не имеют ограничений по технической поддержке',
      },
      {
        title: 'Номенклатура',
        items: [
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.dishes.href.slice(1)}`}
                    target="_blank"
                >
                  Блюда
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.polufabrikaty.href.slice(1)}`}
                    target="_blank"
                >
                  Полуфабрикаты
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.modifikatory.href.slice(1)}`}
                    target="_blank"
                >
                  Модификаторы
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.tovary.href.slice(1)}`}
                    target="_blank"
                >
                  Товары
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.versionnost_tekhnologicheskikh_kart.href.slice(1)}`}
                    target="_blank"
                >
                  Технологические карты с возможностью версионирования
                </a>
            ),
            web: false,
            start: false,
            standard: true,
            pro: true,
          },
          {
            name: 'Расчет выхода готовой продукции',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Меню',
            web: false,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Норма закладки',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: 'Склад',
        items: [
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.prikhodnye_nakladnye.href.slice(1)}`}
                    target="_blank"
                >
                  Приходные накладные
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.raskhodnye_nakladnye.href.slice(1)}`}
                    target="_blank"
                >
                  Расходные накладные
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.vnutrennie_peremeshcheniya.href.slice(1)}`}
                    target="_blank"
                >
                  Внутренние перемещения
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.akty_spisaniya.href.slice(1)}`}
                    target="_blank"
                >
                  Акты списания
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.akty_prigotovleniya.href.slice(1)}`}
                    target="_blank"
                >
                  Акты приготовления
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.inventarizatsiya.href.slice(1)}`}
                    target="_blank"
                >
                  Акты инвентаризации
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.akty_razbora.href.slice(1)}`}
                    target="_blank"
                >
                  Акты разбора
                </a>
            ),
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.reworking.href.slice(1)}`}
                    target="_blank"
                >
                  Акты переработки
                </a>
            ),
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
          {
            name: 'Мобильный склад в кассовом приложении',
            web: false,
            start: false,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: 'Финансы',
        items: [
          {
            name: 'Дополнительные счета',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
          {
            name: 'Проводки по неосновным видам деятельности',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
          {
            name: 'Финансовый отчет',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
        ],
      },
      {
        title: 'Справочники',
        items: [
          {
            name: 'Единицы измерения',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Категории товаров',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Контрагенты',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Причины списания',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Фасовки',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: (
            <a
                href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.tipy_oplat.href.slice(1)}`}
                target="_blank"
            >
              Типы оплат
            </a>
        ),
        items: [
          {
            name: 'Наличные',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Оплата по картам',
            web: false,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Бонусы',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Пользовательские типы оплат',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
        ],
      },
      {
        title: 'Персонал',
        items: [
          {
            name: 'Предустановленные должности',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Создание собственных должностей',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Учет рабочего времени',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
          {
            name: 'Расчет зарплат сотрудникам',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
        ],
      },
      {
        title: 'CRM',
        items: [
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.fiksirovannye_skidki.href.slice(1)}`}
                    target="_blank"
                >
                  Фиксированные скидки
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.shedule_discount.href.slice(1)}`}
                    target="_blank"
                >
                  Скидки по расписанию
                </a>
            ),
            web: false,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.bonusnye_programmy_.href.slice(1)}`}
                    target="_blank"
                >
                  Бонусные программы
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Накопительные скидки',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.offers.href.slice(1)}`}
                    target="_blank"
                >
                  Акции
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.nadbavki.href.slice(1)}`}
                    target="_blank"
                >
                  Надбавки
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Группы клиентов',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'RFM-анализ',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
        ],
      },
      {
        title: (
            <a
                href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.defaultreports.href.slice(1)}`}
                target="_blank"
            >
              Отчеты
            </a>
        ),
        items: [
          {
            name: 'По продажам',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'По блюдам',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'По сотрудникам',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'По местам реализации',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Движение товаров',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'По часам',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'По дням',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'По модификаторам',
            web: false,
            start: false,
            standard: true,
            pro: true,
          },
          {
            name: 'ABC-анализ',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.support.genreports.href.slice(1)}`}
                    target="_blank"
                >
                  Редактор пользовательских отчетов
                </a>
            ),
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
        ],
      },
      {
        title: 'Режимы работы терминала',
        items: [
          {
            name: 'Со столиками',
            web: false,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Точка быстрого питания',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: (
            <span className={style.titleWithPrDesktop}>
              Работа с периферийным оборудованием
            </span>
        ),
        items: [
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.shop.fiscalRegistrars.href.slice(1)}`}
                    target="_blank"
                >
                  Фискальные регистраторы
                </a>
            ),
            web: false,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.shop.ticketPrinters.href.slice(1)}`}
                    target="_blank"
                >
                  Сетевые тикет-принтетры
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Банковские POS-терминалы',
            web: (<span className={style.nowrapDesktop}>Работа в автономном режиме</span>),
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Электронные весы',
            web: false,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Сканеры штрих-кодов',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: 'Работа с кассовым терминалом',
        items: [
          {
            name: 'Деление чека по организациям',
            web: false,
            start: false,
            standard: true,
            pro: true,
          },
          {
            name: 'Отложенные заказы',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Оплата чека разными типами оплат',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Печать пречеков',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Быстрый чек',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Возвраты',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Отмены со списанием/без списания',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Инкассация/внесение наличных',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Фиксированная стоимость доставки',
            web: false,
            start: false,
            standard: true,
            pro: true,
          },
          {
            name: 'Электронные чеки',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: 'Взаимодействие с кухней',
        items: [
          {
            name: 'Печать кухонных тикетов',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Распределение блюд по местам приготовления',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Терминал повара',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: 'Интеграция со сторонними сервисами',
        items: [
          {
            name: (
                <a
                    href={`${externalLinks.quickrestoRU.href}${pagesLinks.api.href.slice(1)}`}
                    target="_blank"
                >
                  Открытый API
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: 'Возможность подключения тарифных опций',
        items: [
          {
            name: 'Яндекс.Еда',
            web: false,
            start: false,
            standard: true,
            pro: true,
          },
        ],
      },
    ]
  }

  if (locale === 'ru-KZ') {
    return [
      {
        title: 'Цены',
        items: [
          {
            name: 'Стоимость одного терминала в месяц',
            web: '9 000 ₸',
            start: '17 000 ₸',
            standard: '22 500 ₸',
            pro: '28 500 ₸',
          },
          {
            name: 'Стоимость одного терминала в год',
            web: '70 800 ₸',
            start: '170 000 ₸',
            standard: '225 000 ₸',
            pro: '285 000 ₸',
          },
          {
            name: 'Стоимость доп. терминала в месяц',
            web: '3 000 ₸',
            start: '8 550 ₸',
            standard: '11 350 ₸',
            pro: '14 200 ₸',
          },
          {
            name: 'Стоимость доп. терминала в год',
            web: '30 000 ₸',
            start: '85 500 ₸',
            standard: '113 500 ₸',
            pro: '142 000 ₸',
          },
        ],
      },
      {
        title: 'Платформа кассового терминала',
        items: [
          {
            name: 'Операционная система',
            web: 'Windows, Android',
            start: 'iPadOS',
            standard: 'iPadOS',
            pro: 'iPadOS',
          },
        ],
      },
      {
        title: 'Ограничения',
        items: [
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/enterprise/enterprises/"
                    target="_self"
                >
                  Компаний (юр.лиц)
                </a>
            ),
            web: 'Без ограничений',
            start: '1',
            standard: 'Без ограничений',
            pro: 'Без ограничений',
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/enterprise/venues/"
                    target="_self"
                >
                  Заведений
                </a>
            ),
            web: 'Без ограничений',
            start: '1',
            standard: '5',
            pro: 'Без ограничений',
          },
          {
            name: 'Терминалов (касс)',
            web: 'Без ограничений',
            start: '2',
            standard: '10',
            pro: '49',
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/enterprise/cookingplaces/"
                    target="_self"
                >
                  Мест приготовления
                </a>
            ),
            web: 'Без ограничений',
            start: '2',
            standard: 'Без ограничений',
            pro: 'Без ограничений',
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/enterprise/saleplaces/"
                    target="_self"
                >
                  Мест реализации
                </a>
            ),
            web: 'Без ограничений',
            start: '2',
            standard: 'Без ограничений',
            pro: 'Без ограничений',
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/enterprise/warehouses/"
                    target="_self"
                >
                  Складов
                </a>
            ),
            web: 'Без ограничений',
            start: '2',
            standard: 'Без ограничений',
            pro: 'Без ограничений',
          },
          {
            name: 'Сотрудников',
            web: 'Без ограничений',
            start: '10',
            standard: '30',
            pro: 'Без ограничений',
          },
          {
            name: 'Периферийных устройств (ФР, принтеров, весов и т. д.)',
            web: 'ФР и принтеры чеков без ограничений',
            start: '10',
            standard: '30',
            pro: 'Без ограничений',
          },
        ],
      },
      {
        title: 'Техническая поддержка',
        items: [
          {
            name: 'Почта',
            web: '24/7',
            start: '24/7',
            standard: '24/7',
            pro: '24/7',
          },
          {
            name: 'Чат',
            web: '24/7',
            start: '24/7',
            standard: '24/7',
            pro: '24/7',
          },
          {
            name: 'Телефон (обращение по проблеме)',
            web: false,
            start: false,
            standard: '24/7',
            pro: '24/7',
          },
          {
            name: 'Телефон (консультация)',
            web: false,
            start: false,
            standard: false,
            pro: '24/7',
          },
        ],
        footer:
            'Тарифы Enterprise, Franchise, а также Trial не имеют ограничений по технической поддержке',
      },
      {
        title: 'Номенклатура',
        items: [
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/nomenklatura/dishes/"
                    target="_self"
                >
                  Блюда
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/nomenklatura/polufabrikaty/"
                    target="_self"
                >
                  Полуфабрикаты
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/nomenklatura/modifikatory/"
                    target="_self"
                >
                  Модификаторы
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/nomenklatura/tovary/"
                    target="_self"
                >
                  Товары
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/nomenklatura/versionnost_tekhnologicheskikh_kart/"
                    target="_self"
                >
                  Технологические карты с возможностью версионирования
                </a>
            ),
            web: false,
            start: false,
            standard: true,
            pro: true,
          },
          {
            name: 'Расчет выхода готовой продукции',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Меню',
            web: false,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Норма закладки',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: 'Склад',
        items: [
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/sklad/prikhodnye_nakladnye/"
                    target="_self"
                >
                  Приходные накладные
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/sklad/raskhodnye_nakladnye/"
                    target="_self"
                >
                  Расходные накладные
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/sklad/vnutrennie_peremeshcheniya/"
                    target="_self"
                >
                  Внутренние перемещения
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/sklad/akty_spisaniya/"
                    target="_self"
                >
                  Акты списания
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/sklad/akty_prigotovleniya/"
                    target="_self"
                >
                  Акты приготовления
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/sklad/inventarizatsiya/"
                    target="_self"
                >
                  Акты инвентаризации
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/sklad/akty_razbora/"
                    target="_self"
                >
                  Акты разбора
                </a>
            ),
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/sklad/akty_razbora/#reworking/"
                    target="_self"
                >
                  Акты переработки
                </a>
            ),
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
          {
            name: 'Мобильный склад в кассовом приложении',
            web: false,
            start: false,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: 'Финансы',
        items: [
          {
            name: 'Дополнительные счета',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
          {
            name: 'Проводки по неосновным видам деятельности',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
          {
            name: 'Финансовый отчет',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
        ],
      },
      {
        title: 'Справочники',
        items: [
          {
            name: 'Единицы измерения',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Категории товаров',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Контрагенты',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Причины списания',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Фасовки',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: (
            <a
                href="/support/rabota_s_bek_ofisom/spravochniki/tipy_oplat/"
                target="_self"
            >
              Типы оплат
            </a>
        ),
        items: [
          {
            name: 'Наличные',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Оплата по картам',
            web: false,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Бонусы',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Пользовательские типы оплат',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
        ],
      },
      {
        title: 'Персонал',
        items: [
          {
            name: 'Предустановленные должности',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Создание собственных должностей',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Учет рабочего времени',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
          {
            name: 'Расчет зарплат сотрудникам',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
        ],
      },
      {
        title: 'CRM',
        items: [
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/crm/discounts_/#fixed_discounts"
                    target="_self"
                >
                  Фиксированные скидки
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/crm/discounts_/#shedule_discount"
                    target="_self"
                >
                  Скидки по расписанию
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/crm/bonusnye_programmy_/"
                    target="_self"
                >
                  Бонусные программы
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Накопительные скидки',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a href="/support/rabota_s_bek_ofisom/crm/offers/" target="_self">
                  Акции
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a href="/support/rabota_s_bek_ofisom/crm/nadbavki/" target="_self">
                  Надбавки
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Группы клиентов',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'RFM-анализ',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
        ],
      },
      {
        title: (
            <a
                href="/support/rabota_s_bek_ofisom/reports/defaultreports/"
                target="_self"
            >
              Отчеты
            </a>
        ),
        items: [
          {
            name: 'По продажам',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'По блюдам',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'По сотрудникам',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'По местам реализации',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Движение товаров',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'По часам',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'По дням',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'По модификаторам',
            web: false,
            start: false,
            standard: true,
            pro: true,
          },
          {
            name: 'ABC-анализ',
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
          {
            name: (
                <a
                    href="/support/rabota_s_bek_ofisom/reports/genreports/"
                    target="_self"
                >
                  Редактор пользовательских отчетов
                </a>
            ),
            web: false,
            start: false,
            standard: false,
            pro: true,
          },
        ],
      },
      {
        title: 'Режимы работы терминала',
        items: [
          {
            name: 'Со столиками',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Точка быстрого питания',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: (
            <span className={style.titleWithPrDesktop}>
              Работа с периферийным оборудованием
            </span>
        ),
        items: [
          {
            name: (
                <a href="/shop/fiskalnye_registratory/" target="_self">
                  Фискальные регистраторы
                </a>
            ),
            web: false,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: (
                <a href="/shop/tiket_printery/" target="_self">
                  Сетевые тикет-принтетры
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Банковские POS-терминалы',
            web: (<span className={style.nowrapDesktop}>Работа в автономном режиме</span>),
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Электронные весы',
            web: false,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Сканеры штрих-кодов',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: 'Работа с кассовым терминалом',
        items: [
          {
            name: 'Деление чека по организациям',
            web: false,
            start: false,
            standard: true,
            pro: true,
          },
          {
            name: 'Отложенные заказы',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Оплата чека разными типами оплат',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Печать пречеков',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Быстрый чек',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Возвраты',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Отмены со списанием/без списания',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Инкассация/внесение наличных',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Фиксированная стоимость доставки',
            web: false,
            start: false,
            standard: true,
            pro: true,
          },
          {
            name: 'Электронные чеки',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: 'Взаимодействие с кухней',
        items: [
          {
            name: 'Печать кухонных тикетов',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Распределение блюд по местам приготовления',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
          {
            name: 'Терминал повара',
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: 'Интеграция со сторонними сервисами',
        items: [
          {
            name: (
                <a href="/api/" target="_self">
                  Открытый API
                </a>
            ),
            web: true,
            start: true,
            standard: true,
            pro: true,
          },
        ],
      },
      {
        title: 'Возможность подключения тарифных опций',
        items: [
          {
            name: 'Яндекс.Еда',
            web: false,
            start: false,
            standard: true,
            pro: true,
          },
        ],
      },
    ]
  }

  return [
    {
      title: "Цены",
      items: [
        {
          name: "Стоимость одного терминала в месяц",
          web: "1 990 ₽",
          start: "3 490 ₽",
          standard: "4 990 ₽",
          pro: "5 990 ₽",
        },
        {
          name: "Стоимость одного терминала в год",
          web: "19 880 ₽",
          start: "34 880 ₽",
          standard: "49 880 ₽",
          pro: "59 880 ₽",
        },
        {
          name: "Стоимость доп. терминала в месяц",
          web: "1 500 ₽",
          start: "2 000 ₽",
          standard: "2 500 ₽",
          pro: "3 000 ₽",
        },
        {
          name: "Стоимость доп. терминала в год",
          web: "15 000 ₽",
          start: "20 000 ₽",
          standard: "25 000 ₽",
          pro: "30 000 ₽",
        },
      ],
    },
    {
      title: 'Платформа кассового терминала',
      items: [
        {
          name: 'Операционная система',
          web: 'Windows, Android',
          start: 'iPadOS',
          standard: 'iPadOS',
          pro: 'iPadOS',
        },
      ],
    },
    {
      title: 'Ограничения',
      items: [
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/enterprise/enterprises/"
                  target="_self"
              >
                Компаний (юр.лиц)
              </a>
          ),
          web: 'Без ограничений',
          start: '1',
          standard: 'Без ограничений',
          pro: 'Без ограничений',
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/enterprise/venues/"
                  target="_self"
              >
                Заведений
              </a>
          ),
          web: 'Без ограничений',
          start: '1',
          standard: '5',
          pro: 'Без ограничений',
        },
        {
          name: 'Терминалов (касс)',
          web: 'Без ограничений',
          start: '2',
          standard: '10',
          pro: '49',
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/enterprise/cookingplaces/"
                  target="_self"
              >
                Мест приготовления
              </a>
          ),
          web: 'Без ограничений',
          start: '2',
          standard: 'Без ограничений',
          pro: 'Без ограничений',
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/enterprise/saleplaces/"
                  target="_self"
              >
                Мест реализации
              </a>
          ),
          web: 'Без ограничений',
          start: '2',
          standard: 'Без ограничений',
          pro: 'Без ограничений',
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/enterprise/warehouses/"
                  target="_self"
              >
                Складов
              </a>
          ),
          web: 'Без ограничений',
          start: '2',
          standard: 'Без ограничений',
          pro: 'Без ограничений',
        },
        {
          name: 'Сотрудников',
          web: 'Без ограничений',
          start: '10',
          standard: '30',
          pro: 'Без ограничений',
        },
        {
          name: 'Периферийных устройств (ФР, принтеров, весов и т. д.)',
          web: 'ФР и принтеры чеков без ограничений',
          start: '10',
          standard: '30',
          pro: 'Без ограничений',
        },
      ],
    },
    {
      title: 'Техническая поддержка',
      items: [
        {
          name: 'Почта',
          web: '24/7',
          start: '24/7',
          standard: '24/7',
          pro: '24/7',
        },
        {
          name: 'Чат',
          web: '24/7',
          start: '24/7',
          standard: '24/7',
          pro: '24/7',
        },
        {
          name: 'Телефон (обращение по проблеме)',
          web: false,
          start: false,
          standard: '24/7',
          pro: '24/7',
        },
        {
          name: 'Телефон (консультация)',
          web: false,
          start: false,
          standard: false,
          pro: '24/7',
        },
      ],
      footer:
          'Тарифы Enterprise, Franchise, а также Trial не имеют ограничений по технической поддержке',
    },
    {
      title: 'Номенклатура',
      items: [
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/nomenklatura/dishes/"
                  target="_self"
              >
                Блюда
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/nomenklatura/polufabrikaty/"
                  target="_self"
              >
                Полуфабрикаты
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/nomenklatura/modifikatory/"
                  target="_self"
              >
                Модификаторы
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/nomenklatura/tovary/"
                  target="_self"
              >
                Товары
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/nomenklatura/versionnost_tekhnologicheskikh_kart/"
                  target="_self"
              >
                Технологические карты с возможностью версионирования
              </a>
          ),
          web: false,
          start: false,
          standard: true,
          pro: true,
        },
        {
          name: 'Расчет выхода готовой продукции',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Меню',
          web: false,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Норма закладки',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
      ],
    },
    {
      title: 'Склад',
      items: [
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/sklad/prikhodnye_nakladnye/"
                  target="_self"
              >
                Приходные накладные
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/sklad/raskhodnye_nakladnye/"
                  target="_self"
              >
                Расходные накладные
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/sklad/vnutrennie_peremeshcheniya/"
                  target="_self"
              >
                Внутренние перемещения
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/sklad/akty_spisaniya/"
                  target="_self"
              >
                Акты списания
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/sklad/akty_prigotovleniya/"
                  target="_self"
              >
                Акты приготовления
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/sklad/inventarizatsiya/"
                  target="_self"
              >
                Акты инвентаризации
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/sklad/akty_razbora/"
                  target="_self"
              >
                Акты разбора
              </a>
          ),
          web: false,
          start: false,
          standard: false,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/sklad/akty_razbora/#reworking/"
                  target="_self"
              >
                Акты переработки
              </a>
          ),
          web: false,
          start: false,
          standard: false,
          pro: true,
        },
        {
          name: 'Мобильный склад в кассовом приложении',
          web: false,
          start: false,
          standard: true,
          pro: true,
        },
      ],
    },
    {
      title: 'Финансы',
      items: [
        {
          name: 'Дополнительные счета',
          web: false,
          start: false,
          standard: false,
          pro: true,
        },
        {
          name: 'Проводки по неосновным видам деятельности',
          web: false,
          start: false,
          standard: false,
          pro: true,
        },
        {
          name: 'Финансовый отчет',
          web: false,
          start: false,
          standard: false,
          pro: true,
        },
      ],
    },
    {
      title: 'Справочники',
      items: [
        {
          name: 'Единицы измерения',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Категории товаров',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Контрагенты',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Причины списания',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Фасовки',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
      ],
    },
    {
      title: (
          <a
              href="/support/rabota_s_bek_ofisom/spravochniki/tipy_oplat/"
              target="_self"
          >
            Типы оплат
          </a>
      ),
      items: [
        {
          name: 'Наличные',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Оплата по картам',
          web: false,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Бонусы',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Пользовательские типы оплат',
          web: false,
          start: false,
          standard: false,
          pro: true,
        },
      ],
    },
    {
      title: 'Персонал',
      items: [
        {
          name: 'Предустановленные должности',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Создание собственных должностей',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Учет рабочего времени',
          web: false,
          start: false,
          standard: false,
          pro: true,
        },
        {
          name: 'Расчет зарплат сотрудникам',
          web: false,
          start: false,
          standard: false,
          pro: true,
        },
      ],
    },
    {
      title: 'CRM',
      items: [
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/crm/discounts_/#fixed_discounts"
                  target="_self"
              >
                Фиксированные скидки
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/crm/discounts_/#shedule_discount"
                  target="_self"
              >
                Скидки по расписанию
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/crm/bonusnye_programmy_/"
                  target="_self"
              >
                Бонусные программы
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Накопительные скидки',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a href="/support/rabota_s_bek_ofisom/crm/offers/" target="_self">
                Акции
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a href="/support/rabota_s_bek_ofisom/crm/nadbavki/" target="_self">
                Надбавки
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Группы клиентов',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'RFM-анализ',
          web: false,
          start: false,
          standard: false,
          pro: true,
        },
      ],
    },
    {
      title: (
          <a
              href="/support/rabota_s_bek_ofisom/reports/defaultreports/"
              target="_self"
          >
            Отчеты
          </a>
      ),
      items: [
        {
          name: 'По продажам',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'По блюдам',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'По сотрудникам',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'По местам реализации',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Движение товаров',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'По часам',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'По дням',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'По модификаторам',
          web: false,
          start: false,
          standard: true,
          pro: true,
        },
        {
          name: 'ABC-анализ',
          web: false,
          start: false,
          standard: false,
          pro: true,
        },
        {
          name: (
              <a
                  href="/support/rabota_s_bek_ofisom/reports/genreports/"
                  target="_self"
              >
                Редактор пользовательских отчетов
              </a>
          ),
          web: false,
          start: false,
          standard: false,
          pro: true,
        },
      ],
    },
    {
      title: 'Режимы работы терминала',
      items: [
        {
          name: 'Со столиками',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Точка быстрого питания',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
      ],
    },
    {
      title: (
          <span className={style.titleWithPrDesktop}>
              Работа с периферийным оборудованием
            </span>
      ),
      items: [
        {
          name: (
              <a href="/shop/fiskalnye_registratory/" target="_self">
                Фискальные регистраторы
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: (
              <a href="/shop/tiket_printery/" target="_self">
                Сетевые тикет-принтетры
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Банковские POS-терминалы',
          web: (<span className={style.nowrapDesktop}>Работа в автономном режиме</span>),
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Электронные весы',
          web: false,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Сканеры штрих-кодов',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
      ],
    },
    {
      title: 'Работа с кассовым терминалом',
      items: [
        {
          name: 'Деление чека по организациям (ИП/ООО)',
          web: false,
          start: false,
          standard: true,
          pro: true,
        },
        {
          name: 'Отложенные заказы',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Оплата чека разными типами оплат',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Печать пречеков',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Быстрый чек',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Возвраты',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Отмены со списанием/без списания',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Инкассация/внесение наличных',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Фиксированная стоимость доставки',
          web: false,
          start: false,
          standard: true,
          pro: true,
        },
        {
          name: 'Электронные чеки',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
      ],
    },
    {
      title: 'Взаимодействие с кухней',
      items: [
        {
          name: 'Печать кухонных тикетов',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Распределение блюд по местам приготовления',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
        {
          name: 'Терминал повара',
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
      ],
    },
    {
      title: 'Интеграция со сторонними сервисами',
      items: [
        {
          name: (
              <a href="/api/" target="_self">
                Открытый API
              </a>
          ),
          web: true,
          start: true,
          standard: true,
          pro: true,
        },
      ],
    },
    {
      title: 'Возможность подключения тарифных опций',
      items: [
        {
          name: 'Яндекс.Еда',
          web: false,
          start: false,
          standard: true,
          pro: true,
        },
        {
          name: 'Маркет Деливери (Delivery Club)',
          web: false,
          start: false,
          standard: true,
          pro: true,
        },
        {
          name: 'Сбермаркет',
          web: false,
          start: false,
          standard: true,
          pro: true,
        },
        {
          name: 'Своя доставка через сервис Яндекс.Доставка',
          web: false,
          start: false,
          standard: true,
          pro: true,
        },
        {
          name: 'Сервис оплаты за столиком Яндекс.Чек',
          web: false,
          start: false,
          standard: false,
          pro: true,
        },
      ],
    },
  ]
}

